/* Mundo3D — base interactive JS (Shopify-aware) */
(function () {
  /* ---------- HELPERS ---------- */
  function showToast(html, accentTeal) {
    var wrap = document.getElementById('toastWrap');
    if (!wrap) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML =
      '<span class="ic"' + (accentTeal ? ' style="background:var(--teal)"' : '') + '>' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span>' + html + '</span>';
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 400);
    }, 2500);
  }

  /* ---------- CART (Shopify AJAX) ---------- */
  var cartCount = document.getElementById('cartCount');

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        if (cartCount) {
          cartCount.textContent = n;
          cartCount.classList.toggle('show', n > 0);
        }
      })
      .catch(function () {});
  }
  refreshCartCount();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.add-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = b.getAttribute('data-variant-id');
    var name = b.getAttribute('data-name') || 'Producto';
    if (!variantId) { showToast('Selecciona una variante'); return; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (res.ok) {
          refreshCartCount();
          showToast(name + ' agregado al carrito ✓');
        } else {
          var msg = (res.data && (res.data.description || res.data.message)) || 'No se pudo agregar';
          showToast('⚠️ ' + msg);
        }
      })
      .catch(function () {
        showToast('Error de conexión. Intenta de nuevo.');
      });
  });

  /* ---------- POINTS CALCULATOR ---------- */
  var range = document.getElementById('calcRange');
  if (range) {
    function updCalc() {
      var n = parseInt(range.value, 10), total = 0;
      for (var i = 1; i <= n; i++) { total += (i > 10 ? 200 : 100); }
      var el = function (id) { return document.getElementById(id); };
      if (el('calcPts')) el('calcPts').textContent = total.toLocaleString('es-CL');
      if (el('calcBuys')) el('calcBuys').textContent = n;
      if (el('calcMoney')) el('calcMoney').textContent = '$' + total.toLocaleString('es-CL');
      if (el('calcLevel')) el('calcLevel').textContent = n >= 10 ? 'Miembro Pro ★' : 'Miembro';
      if (el('calcRate')) el('calcRate').textContent = (n >= 10 ? '200' : '100') + ' pts';
      var note = el('calcNote');
      if (note) note.textContent = n >= 10
        ? '¡Nivel Pro desbloqueado! Ganas 200 pts por compra + producto gratis. 🎉'
        : 'Te faltan ' + (10 - n) + ' compras para ganar 200 pts por compra y un producto gratis. 🎯';
    }
    range.addEventListener('input', updCalc);
    updCalc();
  }

  /* ---------- MAGNET ---------- */
  var board = document.getElementById('magnetBoard');
  if (board) {
    var labels = ['M', 'U', 'N', 'D', 'O', '3', 'D', '★', '♥', '✓'];
    var mState = parseInt(localStorage.getItem('m3d_magnet') || '0', 10);
    labels.forEach(function (l) {
      var pc = document.createElement('div');
      pc.className = 'mpiece';
      pc.textContent = l;
      board.appendChild(pc);
    });
    var pieces = board.querySelectorAll('.mpiece');

    function renderMagnet(animateIdx) {
      pieces.forEach(function (p, idx) { p.classList.toggle('filled', idx < mState); });
      var mc = document.getElementById('magnetCount');
      if (mc) mc.textContent = mState;
      var rb = document.getElementById('rewardBanner');
      if (rb) rb.classList.toggle('show', mState >= 10);
      if (animateIdx != null && pieces[animateIdx]) {
        pieces[animateIdx].classList.add('pop');
        setTimeout(function () { pieces[animateIdx] && pieces[animateIdx].classList.remove('pop'); }, 480);
      }
    }
    renderMagnet();

    var simBtn = document.getElementById('simBuy');
    if (simBtn) simBtn.addEventListener('click', function () {
      if (mState >= 10) return;
      mState++;
      localStorage.setItem('m3d_magnet', mState);
      renderMagnet(mState - 1);
    });
    var resetBtn = document.getElementById('magnetReset');
    if (resetBtn) resetBtn.addEventListener('click', function () {
      mState = 0;
      localStorage.setItem('m3d_magnet', 0);
      renderMagnet();
    });
  }

  /* ---------- MENU: manejado por el script inline de la sección header ---------- */

  /* ---------- NAV SHADOW ---------- */
  var nav = document.getElementById('nav');
  function onScroll() { if (nav) nav.classList.toggle('scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll);
  onScroll();

  /* ---------- REVEAL ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  function forceShow() {
    document.querySelectorAll('.reveal').forEach(function (el) {
      if (parseFloat(getComputedStyle(el).opacity) < 0.9) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.96) {
          el.style.opacity = '1';
          el.style.transform = 'none';
        }
      }
    });
  }
  function revealInView() {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.96) { el.classList.add('in'); io.unobserve(el); }
    });
  }
  window.addEventListener('load', function () { requestAnimationFrame(revealInView); });
  setTimeout(revealInView, 200);
  setTimeout(forceShow, 520);
  window.addEventListener('scroll', function () { requestAnimationFrame(forceShow); }, { passive: true });
})();
